
<!-- SIDEBAR -->
<aside class="sidebar" [class.open]="menu">
  <div class="logo-wrap">
    <img src="assets/sidebar/logo.png" alt="UMYO Gossip" />
  </div>

  <ul class="menu">
    <li *ngFor="let item of items">
      <!-- Logout item -->
      <a
        *ngIf="item.label === 'Logout'; else normalMenuItem"
        href="javascript:void(0)"
        (click)="logout(); menu = false"
      >
        <i class="ico" [ngClass]="item.icon"></i>
        <span class="label">{{ item.label }}</span>
      </a>

      <!-- Normal menu items -->
      <ng-template #normalMenuItem>
        <a [routerLink]="item.route"
           routerLinkActive="active"
           (click)="menu = false">
          <i class="ico" [ngClass]="item.icon"></i>
          <span class="label">{{ item.label }}</span>
          <b class="badge-count"
             *ngIf="item.badge === 'msg' && msgCount > 0">
            {{ msgCount }}
          </b>
          <b class="badge-live" *ngIf="item.live && liveCount > 0">
            LIVE
          </b>
        </a>
      </ng-template>
    </li>
  </ul>

  <div class="promo">
    <img src="assets/sidebar/promo.jpg" alt="" />
  </div>
</aside>

<div class="sidebar-backdrop" *ngIf="menu" (click)="toggleMenu()"></div>

<!-- TOPBAR -->
<header class="topbar">
  <button class="menu-btn" (click)="toggleMenu()" aria-label="Menu">
    <span></span><span></span><span></span>
  </button>

  <form class="search-box" (submit)="$event.preventDefault()">
    <svg class="s-icon" viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg>
    <input type="search" placeholder="Search your cards, templates, members and more..."
           [(ngModel)]="query" name="searchInput" (keyup)="searchUsers()" autocomplete="off" />

    <div class="search-results" *ngIf="searchResults.length > 0 && query != ''">
      <div class="result-item" *ngFor="let result of searchResults"
           (click)="closeSearch()" [routerLink]="'/user/' + result.id">
        <img [src]="getPhoto(result)" (error)="$any($event.target).src='assets/images/avatar.png'"
        class="avatar-image" alt="{{ result.firstname }}" />
        <p>{{ result.firstname + ' ' + result.lastname }}</p>
      </div>
    </div>
  </form>

  <div class="top-right">
    <button class="bell" aria-label="Notifications">
      <i class="fa-solid fa-bell"></i>
      <b class="bell-badge" *ngIf="notifCount > 0">{{ notifCount }}</b>
    </button>

    <span class="divider"></span>

    <div class="profile-wrap">
      <div class="profile" (click)="profileOpen = !profileOpen">
        <img [src]="userPhoto" (error)="userPhoto='assets/images/avatar.png'" class="p-avatar" alt="" />
        <div class="p-info">
          <div class="p-name">{{ userName }}</div>
          <div class="p-role">{{ userRole }}</div>
        </div>
        <i class="fa-solid fa-chevron-down chev"></i>
      </div>

      <div class="p-menu" *ngIf="profileOpen">
        <a routerLink="/profile" (click)="profileOpen = false">Profile</a>
        <!-- <a routerLink="/settings" (click)="profileOpen = false">Settings</a> -->
        <a (click)="logout()">Logout</a>
      </div>
    </div>
  </div>
</header>